import styled, { CSSObject } from '@emotion/styled'
import { UseFormRegister } from 'react-hook-form'
import { FormFields } from './types'
import { CheckboxInput } from '../Inputs'

type Props = {
  register: UseFormRegister<FormFields>
}

const CustomerOptIn = ({ register }: Props) => {
  return (
    <CustomerOptInContainer>
      <CheckboxInput
        type='checkbox'
        id='CustomerDetailsDisclosure'
        {...register('marketingOptIn')}
        name='marketingOptIn'
        disabled={false}
      />
      <Label htmlFor='CustomerDetailsDisclosure'>
        Click to opt in to hear about offers, discounts and news.
      </Label>
    </CustomerOptInContainer>
  )
}

const CustomerOptInContainer = styled.div(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: '14px'
}))

const Label = styled.label(
  ({ theme }): CSSObject => ({
    fontSize: '16px'
  })
)

export default CustomerOptIn
